import { FlowBaseIcon } from '@tableau/icons/FlowBaseIcon';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FlowCard } from '~src/flow/components/cardView/FlowCard';
import { Flows } from '~src/flow/resources/Flows';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { FlowContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const FlowDefinition: MixedContentItemDefinition & SpaceDefinition<'flow'> = {
  itemType: 'flow',
  contentType: 'flow',
  singularName: Messages.flow,
  pluralName: Messages.flows,
  emptyStateMessage: Messages.flowsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Flows,
  contentFilterKeys: FlowContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: FlowCard,
  listViewIconType: FlowBaseIcon,
  filterClause: ServerFilterClauses.ContentType(['flow']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.flowUrl(contentId),
  getBasicQuery: () => {
    return Flows.all().withExtraParams(FlowContentType.extraQueryParams);
  },
  fieldValueResourceType: 'flow',
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for flow');
  },
  headerIconPath: () => imgPath('spaces_masthead_flow.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
};
